var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldDisplay)?_c('ws-state-banner',{staticClass:"cart-item-info-box",attrs:{"title":_vm.title,"text":_vm.text,"icon":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }